import { motion } from "framer-motion";
import { useContext } from "react";
import { CiLogout } from "react-icons/ci";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { UserContext } from "..";
import browserRoutes from "../../../common/browserRoutes";
import styles from "../../../common/styles";
import { DP } from "../../../common/types";
import { ProfileContext } from "../../../context/profileContext";

interface Props extends DP {}

const menuItems = [
  { title: "My Posts", path: browserRoutes.user },
  { title: "Favorite", path: browserRoutes.userLikes },
];

const Menu = (props: Props) => {
  const { mainState, setMainState } = useContext(UserContext);
  const profile = useContext(ProfileContext);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <AnimMenuWrapper
      className={props.className}
      variants={{
        hidden: { height: 0, borderWidth: 0, padding: 0 },
        shown: { height: "auto", borderWidth: "0.05rem" },
      }}
      initial="hidden"
      animate={mainState.isMenuOpened ? "shown" : "hidden"}
    >
      <MenuItems>
        {menuItems.map((el) => (
          <MenuLink to={el.path(profile?.user.username)}>{el.title}</MenuLink>
        ))}
      </MenuItems>
      <LogoutButton onClick={handleLogout}>
        <span>Logout</span>
        <CiLogout />
      </LogoutButton>
    </AnimMenuWrapper>
  );
};

const AnimMenuWrapper = styled(motion.div)(() => [
  tw`bg-white p-[0.1rem] absolute w-full z-10 overflow-hidden flex flex-col items-center`,
  styles.border,
  css`
    border-style: none solid solid solid;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `,
]);

const MenuItems = styled.div(() => [
  tw`flex flex-col items-center w-full my-1`,
]);

const MenuLink = styled(Link)(() => [
  tw`block w-full py-0.5 text-center`,
  css`
    @media (hover: hover) {
      &:hover {
        ${tw`text-white bg-pink-400`}
      }
    }
  `,
]);

const MenuItemButton = styled.button(() => [
  tw`px-1 mx-auto py-0.5 rounded-3xl`,
]);

const LogoutButton = styled.button(() => [
  tw`flex items-center p-1 mx-auto mt-auto space-x-1 rounded-md`,
]);

export default styled(Menu)``;
